import { api } from "..";

import { NewUser } from "@/types/ApiResponses/User";

export interface CreateMainDealerPayload {
  username: string;
  password: string;
  balance?: number;
  agentId?: number;
  bettingRulesLocked?: boolean;
}

export const createMainDealer = async (
  payload: CreateMainDealerPayload
): Promise<NewUser> => {
  const res = await api.client.post("/dealers-new", payload);
  return res.data;
};
